import { BRAND_NAME } from '@/lib/constants';
import { useWhitelabel } from '@/hooks/api/use-whitelabel';

import SmallSpinner from '@/components/shared/spinners/small-spinner';
import Page from '@/components/layout/app-shell';

const Whitelabel = () => {
    const whitelabel = useWhitelabel();

    document.title = `Accueil | ${BRAND_NAME} - Espace assuré`;

    if (whitelabel.isLoading) {
        return <SmallSpinner />;
    }

    return <Page />;
};

export default Whitelabel;
